import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DragState {
    draggedItems: string[]
    isDragging: boolean
}

const initialState: DragState = {
    draggedItems: [],
    isDragging: false
}

const dragSlice = createSlice({
    name: 'drag',
    initialState,
    reducers: {
        startDrag: (state, action: PayloadAction<string[]>) => {
            state.draggedItems = action.payload
            state.isDragging = true
        },
        endDrag: (state) => {
            state.draggedItems = []
            state.isDragging = false
        }
    }
})

export const { startDrag, endDrag } = dragSlice.actions
export default dragSlice.reducer 